var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPadlock = function SvgPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14244_91549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.63855 6.90294V8.78222H4.51375C3.7246 8.78222 3.08594 9.42088 3.08594 10.21V18.0722C3.08594 18.8613 3.7246 19.5 4.51375 19.5H15.4848C16.2739 19.5 16.9126 18.8613 16.9126 18.0722V10.21C16.9126 9.42088 16.2739 8.78222 15.4848 8.78222H15.4481V6.90294C15.4481 3.92251 13.0256 1.5 10.0452 1.5C7.06106 1.5 4.63855 3.92618 4.63855 6.90294ZM7.00233 6.90294C7.00233 5.22553 8.36775 3.86378 10.0415 3.86378C11.7189 3.86378 13.0806 5.2292 13.0806 6.90294V8.78222H7.00233V6.90294Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14244_91549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1.5)"
  })))));
};
export default SvgPadlock;